import _objectSpread from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["bsPrefix", "fluid", "as", "className"];
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultProps = {
  fluid: false
};
const Container = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      bsPrefix,
      fluid,
      // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
      as: Component = 'div',
      className
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const prefix = useBootstrapPrefix(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? "-".concat(fluid) : '-fluid';
  return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: classNames(className, fluid ? "".concat(prefix).concat(suffix) : prefix)
  }));
});
Container.displayName = 'Container';
Container.defaultProps = defaultProps;
export default Container;